import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Twitch, Sparkles, Tag } from 'lucide-react';
import { heroData } from '../data/mock';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const [visible, setVisible] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [commissionsOpen, setCommissionsOpen] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    axios.get(`${API}/settings`).then(res => {
      setCommissionsOpen(res.data.commissions_open);
    }).catch(() => {});
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
        style={{
          backgroundImage: `url("${heroData.backgroundImage}")`,
          filter: 'blur(2px)',
        }}
      />
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-stone-800/60 via-neutral-800/40 to-slate-950/95" />

      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto">
        <div
          className={`transition-all duration-1000 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h1 className="text-6xl md:text-8xl font-bold bg-gradient-to-r from-cyan-300 via-teal-400 to-cyan-400 bg-clip-text text-transparent mb-6 drop-shadow-2xl">
            {heroData.title}
          </h1>
          <p className="text-2xl md:text-3xl bg-gradient-to-r from-cyan-300 to-teal-300 bg-clip-text text-transparent mb-8 font-semibold">
            {heroData.subtitle}
          </p>
          <p className="text-lg md:text-xl text-gray-300 mb-12 max-w-2xl mx-auto">
            {heroData.description}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href={heroData.twitchUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="inline-flex items-center justify-center gap-2 font-medium rounded-md bg-gradient-to-r from-teal-600 to-cyan-600 hover:from-teal-500 hover:to-cyan-500 text-white px-8 py-4 text-lg shadow-2xl shadow-cyan-500/50 hover:shadow-cyan-500/70 transition-all duration-300 hover:scale-105">
                <Twitch className="w-6 h-6" />
                Watch on Twitch
              </button>
            </a>
            <Link to="/Commission">
              <button className="inline-flex items-center justify-center gap-2 font-medium rounded-md border-2 border-cyan-400 text-cyan-400 hover:bg-gradient-to-r hover:from-cyan-500 hover:to-teal-500 hover:text-white hover:border-transparent px-8 py-4 text-lg shadow-2xl shadow-cyan-500/30 hover:shadow-cyan-500/50 transition-all duration-300 hover:scale-105 bg-transparent">
                <Sparkles className="w-6 h-6" />
                Commission Me
              </button>
            </Link>
            <Link to="/DiscountOptions">
              <button className="inline-flex items-center justify-center gap-2 font-medium rounded-md border-2 border-amber-600 text-amber-600 hover:bg-gradient-to-r hover:from-amber-600 hover:to-yellow-600 hover:text-white hover:border-transparent px-8 py-4 text-lg shadow-2xl shadow-amber-600/30 hover:shadow-amber-600/50 transition-all duration-300 hover:scale-105 bg-transparent">
                <Tag className="w-6 h-6" />
                View Discounts
              </button>
            </Link>
          </div>

          <div className="mt-12">
            {commissionsOpen ? (
              <span className="inline-flex items-center rounded-md font-semibold text-lg px-6 py-2 bg-green-500 text-white shadow">
                Commissions Open
              </span>
            ) : (
              <span className="inline-flex items-center rounded-md font-semibold text-lg px-6 py-2 bg-red-500 text-white shadow">
                Commissions Closed
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
        style={{ transform: `translate(-50%, ${Math.sin(Date.now() / 600) * 6}px)` }}
      >
        <div className="w-6 h-10 border-2 border-cyan-400 rounded-full flex justify-center animate-bounce">
          <div className="w-1 h-3 bg-cyan-400 rounded-full mt-2" />
        </div>
      </div>
    </section>
  );
};

export default Home;
